import React from "react";
import { useDispatch } from "react-redux";
import { setFocusedElement } from "../../../../actions/taskSidebar";
import PanelVisibilty from "./PanelVisibilty";
import ViewSelection from "./ViewSelection";
import "./WorkflowElements.scss";

/**
 * Task sidebar panel: Task View + Panel Visibility (moved from Flow Elements).
 */
const ViewControlPanel = () => {
  const dispatch = useDispatch();

  const handleFocus = () => {
    dispatch(setFocusedElement("task-view-control"));
  };

  return (
    <div onClick={handleFocus}>
      <ViewSelection />
      <PanelVisibilty />
    </div>
  );
};

export default ViewControlPanel;
